export class ConfirmParamModel {
	public ref: string;
	public fileName: string;
}
